
import React from "react";
import styled from "styled-components"
import media from "styled-media-query";

const LogoType = styled.div`
    width: 100%;
    margin-bottom: 12px;

    svg {
        max-width: 120px;
    }

    ${media.greaterThan("medium")`
        padding: 0;
        margin-bottom: 25px;

        input {
            font-size: 24px;
        }
    `}
`

const Wordmark = styled.span`
    font-family: ovhead, sans-serif;
    font-weight: 300;
    font-size: 22px;
    letter-spacing: 0.32em;
    text-transform: uppercase;
    color: #1b1b1b;
`;

// Footer wordmark, matching the header.
const FooterLogo = () => (
  <LogoType>
    <Wordmark>Overview</Wordmark>
  </LogoType>
);

export default FooterLogo;
